import { lazy } from 'react';

export const ExpertEstimation = lazy(() => import('./ExpertEstimation'));
export const ExpertHomePage = lazy(() => import('./ExpertHomePage'));
export const ExpertQuoteForm = lazy(() => import('./ExpertQuoteForm'));
export const ExpertQuotePage = lazy(() => import('./ExpertQuotePage'));
export const ExpertQuoteFollowup = lazy(() => import('./ExpertQuoteFollowup'));
export const ExpertQuotes = lazy(() => import('./ExpertQuotes'));
export const ExpertAdministrationPage = lazy(() => import('./ExpertAdministrationPage'));
